import { Injectable, Injector } from '@angular/core';
import 'rxjs/Rx';

// operators
import "rxjs/add/operator/catch"
import "rxjs/add/observable/throw"
import "rxjs/add/operator/map"

declare var keyczar: any;

@Injectable()
export class UtilCifradoService {

    static _instance: UtilCifradoService;
    static isCreating: Boolean = false;
    private _injector: Injector;
    instance: any;
    keys: any;

    constructor() {
        this.keys = {
            meta: "{\"name\":\"\",\"purpose\":\"DECRYPT_AND_ENCRYPT\",\"type\":\"AES\",\"versions\":[{\"exportable\":false,\"status\":\"PRIMARY\",\"versionNumber\":1}],\"encrypted\":false}",
            1: "{\"aesKeyString\":\"JfEMByS4DjhzoPGJRtiE1A\",\"hmacKey\":{\"hmacKeyString\":\"cijFnmB6azfcR7wKOjbQHAU2ihPjenQI2hwM9kO4e78\",\"size\":256},\"mode\":\"CBC\",\"size\":128}"
        };
        //this.instance = keyczar.fromJson(JSON.stringify(this.keys)); 
    }

    cifrar(text: string): string {
        return this.instance.encrypt(text);
    }

    decifrar(text: string): string {
        return this.instance.decrypt(text);
    } 

    public getInjector(): Injector {
        return this._injector;
    }

    public static getInstance() {
        if (UtilCifradoService._instance == null) {
            UtilCifradoService.isCreating = true;
            UtilCifradoService._instance = new UtilCifradoService();
            UtilCifradoService.isCreating = false;
        }

        return UtilCifradoService._instance;
    }
}


// WEBPACK FOOTER //
// D:/OficinaVirtual/FrontEndFinamco/EFactoringManager/src/app/servicios/util-cifrado.service.ts